import { useRef } from 'react';
import { makeStyles } from '@material-ui/styles';

import { UserBadge } from '@bizzabo/collaboration-common';
import { User, useProfileIdByChatId } from '@bizzabo/entities';

type ContactListItemProps = {
    user: User;
    eventId: number;
    onClick: (attendeeId: number) => void;
};

const ContactListItem: React.FC<ContactListItemProps> = ({ user, eventId, onClick }) => {
    const classes = useStyles();
    const isCreateChannelCalled = useRef(false);

    const { refetch } = useProfileIdByChatId({
        chatId: user.id,
        eventId,
        options: {
            enabled: false,
            onSuccess: onClick,
        },
    });

    const onItemClick = () => {
        if (!isCreateChannelCalled.current) {
            refetch();
            isCreateChannelCalled.current = true;
        }
    };

    return (
        <div className={classes.itemContent} onClick={onItemClick}>
            <UserBadge sizeOfAvatar={40} user={user} titleVariant="t60" />
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        itemContent: {
            height: 74,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 24,
            borderTop: `solid 1px ${theme.palette.greys[300]}`,
            cursor: 'pointer',
            overflow: 'hidden',
            marginTop: -1,
            paddingRight: 10,
        },
    }),
    { classNamePrefix: ContactListItem.name }
);

export default ContactListItem;
